import Constants from '@intercom/embercom-composer/lib/constants';
const ZERO_WIDTH_SPACE = Constants.ZERO_WIDTH_SPACE;
const INSERT_TYPES = ['P', 'B', 'I', 'H1', 'H2'];
const TEXT_BLOCK_TYPES = ['P', 'LI'];
const WRAP_TYPES = ['IC-ATTRIBUTE', 'IC-MENTION', 'IC-MARKER', 'CODE'];
const SKIP_TYPES = ['IC-BLOCK'];
export default function (domNode) {
  walk(domNode, manageZeroWidthSpaces);
  return domNode;
}
function manageZeroWidthSpaces(node) {
  if (shouldPrepend(node)) {
    addBefore(node);
  }
  if (shouldInsert(node)) {
    addTo(node);
  }
  if (shouldAppend(node)) {
    addAfter(node);
  }
  if (shouldRemoveFrom(node)) {
    remove(node);
  }
}
function shouldPrepend(node) {
  return isWrapType(node) && (!node.previousSibling || node.previousSibling.tagName === 'BR') || isStartingBreakAndChildOfTextBlock(node);
}
function shouldInsert(node) {
  return isEmptyInsertType(node);
}
function shouldAppend(node) {
  return isTrailingBreak(node) || isWrapType(node);
}
function isEmptyInsertType(node) {
  return isInsertType(node) && node.childNodes.length === 0 && node.textContent !== ZERO_WIDTH_SPACE;
}
function isStartingBreak(node) {
  return node.tagName === 'BR' && node.previousSibling === null;
}
function isTrailingBreak(node) {
  return node.tagName === 'BR' && (node.nextSibling === null || node.nextSibling.tagName === 'BR');
}
function isStartingBreakAndChildOfTextBlock(node) {
  return node.parentNode && isTextBlockType(node.parentNode) && isStartingBreak(node);
}
function isInsertType(node) {
  return INSERT_TYPES.includes(node.tagName);
}
function isWrapType(node) {
  return WRAP_TYPES.includes(node.tagName);
}
function isTextBlockType(node) {
  return TEXT_BLOCK_TYPES.includes(node.tagName);
}
function addTo(node) {
  node.textContent = ZERO_WIDTH_SPACE + node.textContent;
}
function addBefore(node) {
  if (node.previousSibling && isTextNode(node.previousSibling)) {
    addTo(node.previousSibling);
  } else {
    node.parentNode.insertBefore(zeroWidthTextNode(), node);
  }
}
function addAfter(node) {
  if (node.nextSibling && isTextNode(node.nextSibling)) {
    addTo(node.nextSibling);
  } else {
    node.parentNode.insertBefore(zeroWidthTextNode(), node.nextSibling);
  }
}
function shouldRemoveFrom(node) {
  return isTextNode(node) && hasSiblingsOrContent(node) && parentIsNotWrapType(node) && (previousSiblingIsNotWrapTypeOrBr(node) || hasRealContent(node));
}
function previousSiblingIsNotWrapTypeOrBr(node) {
  let previousSibling = node.previousSibling;
  if (!previousSibling) {
    return true;
  }
  return previousSibling.tagName !== 'BR' && !isWrapType(previousSibling);
}
function parentIsNotWrapType(node) {
  return !WRAP_TYPES.includes(node.parentNode.tagName);
}
function hasSiblingsOrContent(node) {
  return node.parentNode.childNodes.length > 1 || hasRealContent(node);
}
function remove(node) {
  node.textContent = node.textContent.replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '');
}
function zeroWidthTextNode() {
  return document.createTextNode(ZERO_WIDTH_SPACE);
}
function isTextNode(node) {
  return node.nodeType === Node.TEXT_NODE;
}
function hasRealContent(node) {
  return node.textContent !== ZERO_WIDTH_SPACE;
}
function walk(node, func) {
  if (!SKIP_TYPES.includes(node.nodeName)) {
    func(node);
    node = node.firstChild;
    while (node) {
      walk(node, func);
      node = node.nextSibling;
    }
  }
}